<h2 mat-dialog-title>Address Info</h2>
<div mat-dialog-content>
    <address-input
        [address$]="address$"
        [builders$]="builders$"
        [buildingTypes$]="buildingTypes$"
        [communities$]="communities$"
        [includeLookup]="includeLookup"
        (onUpdateLookupStatus)="updateLookupStatus($event)"
    ></address-input>
</div>
<mat-dialog-actions class="formActionButtonGroup clearfix">
    <a mat-stroked-button (click)="cancel()"> Cancel </a>
    <button
        mat-raised-button
        color="primary"
        class="new-primary-button"
        [disabled]="!isLookupComplete || !isComplete(address$.value)"
        (click)="saveAddress(address$)"
    >
        Save
    </button>
</mat-dialog-actions>
